import { createContext, useContext } from "react";

export const AccountSheetContext = createContext<() => void>(() => {});

export function useAccountSheet(): () => void {
  return useContext(AccountSheetContext);
}
